import { formDataRequest ,postRequest} from "../libs/AxiosService.util";


export async function serviceCreateWhatsapp(params) {
  return await formDataRequest("whatsapp/templates/create", params);
}
export async function serviceUpdateWhatsapp(params) {
  return await postRequest("whatsapp/templates/update", params);
}
export async function serviceDeleteWhatsapp(params) {
  return await postRequest("whatsapp/templates/delete", params);
}
export async function serviceGetWhatsappDetails(params) {
  return await postRequest("whatsapp/templates/detail", params);
}
export async function serviceGetWhatsapp(params) {
  return await postRequest("whatsapp/templates", params);
}
export async function serviceWhatsappCheck(params) {
  return await postRequest("notificationsories/exists", params);
}
export async function serviceSendWhatsapp(params) {
  return await formDataRequest("Whatsapps/send", params);
}
export async function serviceWhatsappMediaUpload(params) {
  return await formDataRequest("whatsapp/media/resumable/upload", params);
}
export async function serviceWhatsappRecipientExport(params) {
  return await formDataRequest("whatsapp/broadcasts/logs/export", params);
}
